"use client";
import * as v from "react";
import { u as S } from "./useEventCallback-CjuAhyNz.mjs";
import { u as H } from "./useControlled-B2rPEZCb.mjs";
import { u as F } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as V, f as K } from "./FieldRootContext-Cj7-dNhd.mjs";
import { u as L } from "./useRenderElement-B8V3_e8R.mjs";
import { u as O, a as _ } from "./useFieldControlValidation-B3M7EPH2.mjs";
import { u as j } from "./useBaseUiId-a-UPSsPQ.mjs";
const q = /* @__PURE__ */ v.forwardRef(function(c, b) {
  const {
    render: A,
    className: G,
    id: y,
    name: C,
    value: t,
    disabled: E = !1,
    onValueChange: n,
    defaultValue: T,
    ...N
  } = c, {
    state: f,
    name: P,
    disabled: I
  } = V(), s = I || E, m = P ?? C, R = v.useMemo(() => ({
    ...f,
    disabled: s
  }), [f, s]), {
    setControlId: i,
    labelId: D,
    setTouched: p,
    setDirty: M,
    validityData: k,
    setFocused: g,
    setFilled: o,
    validationMode: w
  } = V(), {
    getValidationProps: B,
    getInputValidationProps: U,
    commitValidation: u,
    inputRef: a
  } = O(), l = j(y);
  F(() => (i(l), () => {
    i(void 0);
  }), [l, i]), F(() => {
    var r;
    const e = t != null;
    (r = a.current) != null && r.value || e && t !== "" ? o(!0) : e && t === "" && o(!1);
  }, [a, o, t]);
  const [d, h] = H({
    controlled: t,
    default: T,
    name: "FieldControl",
    state: "value"
  }), x = S((e, r) => {
    h(e), n == null || n(e, r);
  });
  return _({
    id: l,
    name: m,
    commitValidation: u,
    value: d,
    getValue: () => {
      var e;
      return (e = a.current) == null ? void 0 : e.value;
    },
    controlRef: a
  }), L("input", c, {
    ref: b,
    state: R,
    props: [{
      id: l,
      disabled: s,
      name: m,
      ref: a,
      "aria-labelledby": D,
      value: d,
      onChange(e) {
        d != null && x(e.currentTarget.value, e.nativeEvent), M(e.currentTarget.value !== k.initialValue), o(e.currentTarget.value !== "");
      },
      onFocus() {
        g(!0);
      },
      onBlur(e) {
        p(!0), g(!1), w === "onBlur" && u(e.currentTarget.value);
      },
      onKeyDown(e) {
        e.currentTarget.tagName === "INPUT" && e.key === "Enter" && (p(!0), u(e.currentTarget.value));
      }
    }, B(), U(), N],
    customStyleHookMapping: K
  });
});
process.env.NODE_ENV !== "production" && (q.displayName = "FieldControl");
export {
  q as F
};
